import { useEffect, useMemo } from "react";
import { honeyJarsContract } from "config";
import useSnackbarError from "hooks/useSnackbarError";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarSuccess from "hooks/useSnackbarSuccess";

const useMint = (
  tokenIds?: number[],
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data: mintData, loading: isLoading, error: writeError }, mint] =
    useContractWrite(
      {
        addressOrName: honeyJarsContract.address,
        contractInterface: honeyJarsContract.interface,
      },
      "mint",
      {
        args: [tokenIds],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      wait: mintData?.wait,
    });

  useSnackbarError(writeError);
  useSnackbarError(waitError);
  useSnackbarSuccess(waitData);

  useEffect(() => {
    if (!isWaiting && waitData && onSuccess) {
      onSuccess();
    }
  }, [isWaiting, waitData, onSuccess]);

  return useMemo(
    () => [mint, isLoading || isWaiting],
    [mint, isWaiting, isLoading]
  );
};

export default useMint;
